import React from "react"
import { MODE, ButtonGroup } from "baseui/button-group"
import { navigate } from "gatsby-plugin-intl"
import { Button, KIND } from "baseui/button"
import { Block } from "baseui/block"
import Slider from "react-slick"
import { ChevronLeft, ChevronRight } from "baseui/icon"

type CategoryTabsProps = {
  category: string
}

const TabStyle = ({ $isSelected, $theme }: any) => ({
  width: "33.33%",
  fontSize: "12px",
  paddingLeft: "6px",
  paddingRight: "6px",
  [$theme.mediaQuery.medium]: {
    width: "16.67%",
    fontSize: "12.5px",
  },
  [$theme.mediaQuery.large]: {
    fontSize: "15px",
  },
  backgroundImage: $isSelected
    ? "linear-gradient(180deg, #4C4C4C -56.25%, #353535 76.27%)"
    : "",
  backgroundColor: "transparent",
  color: "white",
  borderBottomWidth: "3px",
  borderBottomColor: $isSelected ? $theme.colors.primary : "transparent",
  borderBottomStyle: "solid",
  ":hover": {
    backgroundImage: $isSelected
      ? "linear-gradient(180deg, #4C4C4C -56.25%, #353535 76.27%)"
      : "",
    backgroundColor: "transparent",
  },
})

const categories = [
  { name: "movie", label: "Movie & Series" },
  { name: "entertainment", label: "Entertainment" },
  { name: "knowledge", label: "Knowledge" },
  { name: "sports", label: "Sports" },
  { name: "news", label: "News" },
  { name: "kids", label: "Kids" },
]

const CategoryTabs = ({ category }: CategoryTabsProps) => {
  const selectedIndex = categories.findIndex(({ label }) => label === category)
  const settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    initialSlide: selectedIndex >= 3 ? 1 : 0,
  }
  return (
    <>
      <Block display={["none", "block", "block", "block"]}>
        <ButtonGroup
          selected={selectedIndex}
          mode={MODE.radio}
          onClick={({ currentTarget }) => {
            navigate(`/content/${currentTarget.name}`)
          }}
          overrides={{
            Root: {
              style: {
                background: "linear-gradient(180deg, #646464 0%, #353535 100%)",
              },
            },
          }}
        >
          {categories.map(category => (
            <Button
              key={category.name}
              name={category.name}
              overrides={{
                BaseButton: {
                  style: TabStyle,
                },
              }}
            >
              {category.label}
            </Button>
          ))}
        </ButtonGroup>
      </Block>
      <Block display={["block", "none", "none", "none"]}>
        <Slider {...settings}>
          <ButtonGroup
            selected={selectedIndex}
            mode={MODE.radio}
            onClick={({ currentTarget }) => {
              navigate(`/content/${currentTarget.name}`)
            }}
            overrides={{
              Root: {
                style: {
                  background:
                    "linear-gradient(180deg, #646464 0%, #353535 100%)",
                },
              },
            }}
          >
            {categories.slice(0, 3).map(category => (
              <Button
                key={category.name}
                name={category.name}
                overrides={{
                  BaseButton: {
                    style: TabStyle,
                  },
                }}
              >
                {category.label}
              </Button>
            ))}
          </ButtonGroup>
          <ButtonGroup
            selected={selectedIndex >= 3 && selectedIndex - 3}
            mode={MODE.radio}
            onClick={({ currentTarget }) => {
              navigate(`/content/${currentTarget.name}`)
            }}
            overrides={{
              Root: {
                style: {
                  background:
                    "linear-gradient(180deg, #646464 0%, #353535 100%)",
                },
              },
            }}
          >
            {categories.slice(3, 6).map(category => (
              <Button
                key={category.name}
                name={category.name}
                overrides={{
                  BaseButton: {
                    style: TabStyle,
                  },
                }}
              >
                {category.label}
              </Button>
            ))}
          </ButtonGroup>
        </Slider>
      </Block>
    </>
  )
}

export default CategoryTabs
